import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _UserPasskeys;
import Component from "@glimmer/component";
import { fn } from "@ember/helper";
import { action } from "@ember/object";
import { schedule } from "@ember/runloop";
import { service } from "@ember/service";
import { htmlSafe } from "@ember/template";
import DButton from "discourse/components/d-button";
import ConfirmSession from "discourse/components/dialog-messages/confirm-session";
import PasskeyOptionsDropdown from "discourse/components/user-preferences/passkey-options-dropdown";
import RenamePasskey from "discourse/components/user-preferences/rename-passkey";
import formatDate from "discourse/helpers/format-date";
import { popupAjaxError } from "discourse/lib/ajax-error";
import { bufferToBase64, stringToBuffer, WebauthnAbortHandler } from "discourse/lib/webauthn";
import i18n from "discourse-common/helpers/i18n";
import I18n from "discourse-i18n";
import { setComponentTemplate } from "@ember/component";
import { createTemplateFactory } from "@ember/template-factory";
let UserPasskeys = (_class = (_UserPasskeys = class UserPasskeys extends Component {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "dialog", _descriptor, this);
    _initializerDefineProperty(this, "currentUser", _descriptor2, this);
    _initializerDefineProperty(this, "capabilities", _descriptor3, this);
    _initializerDefineProperty(this, "router", _descriptor4, this);
  }
  get showActions() {
    return this.currentUser.id === this.args.model.id && !this.capabilities.isAppWebview;
  }
  async createPasskey() {
    try {
      const response1 = await this.args.model.createPasskey();
      const publicKeyCredentialCreationOptions1 = {
        challenge: Uint8Array.from(response1.challenge, c1 => c1.charCodeAt(0)),
        rp: {
          name: response1.rp_name,
          id: response1.rp_id
        },
        user: {
          id: Uint8Array.from(response1.user_secure_id, c1 => c1.charCodeAt(0)),
          name: this.currentUser.username,
          displayName: this.currentUser.username
        },
        pubKeyCredParams: response1.supported_algorithms.map(alg1 => {
          return {
            type: "public-key",
            alg: alg1
          };
        }),
        excludeCredentials: response1.existing_passkey_credential_ids.map(credentialId1 => {
          return {
            type: "public-key",
            id: stringToBuffer(atob(credentialId1))
          };
        }),
        authenticatorSelection: {
          // https://www.w3.org/TR/webauthn-2/#user-verification
          // for passkeys (first factor), user verification should be marked as required
          // it ensures browser prompts user for PIN/fingerprint/faceID before authenticating
          userVerification: "required",
          // See https://w3c.github.io/webauthn/#sctn-createCredential for context
          // This ensures that the authenticator stores a client-side private key
          // physical security keys (like Yubikey) need this
          requireResidentKey: true
        }
      };
      const credential1 = await navigator.credentials.create({
        publicKey: publicKeyCredentialCreationOptions1,
        signal: WebauthnAbortHandler.signal()
      });
      let credentialParam1 = {
        id: credential1.id,
        rawId: bufferToBase64(credential1.rawId),
        type: credential1.type,
        attestation: bufferToBase64(credential1.response.attestationObject),
        clientData: bufferToBase64(credential1.response.clientDataJSON),
        name: I18n.t("user.passkeys.name.default")
      };
      const registrationResponse1 = await this.args.model.registerPasskey(credentialParam1);
      if (registrationResponse1.error) {
        this.dialog.alert(registrationResponse1.error);
        return;
      }
      this.router.refresh();
      // Prompt to rename key after creating
      this.dialog.dialog({
        title: I18n.t("user.passkeys.passkey_successfully_created"),
        type: "notice",
        bodyComponent: RenamePasskey,
        bodyComponentModel: registrationResponse1
      });
    } catch (error1) {
      // eslint-disable-next-line no-console
      console.error(error1);
      this.errorMessage = error1.name === "InvalidStateError" ? I18n.t("user.passkeys.already_added_error") : I18n.t("user.passkeys.not_allowed_error");
      this.dialog.alert(this.errorMessage);
    }
  }
  confirmDelete(id1) {
    schedule("afterRender", () => {
      this.dialog.deleteConfirm({
        title: I18n.t("user.passkeys.confirm_delete_passkey"),
        didConfirm: () => {
          this.args.model.deletePasskey(id1).then(() => {
            this.router.refresh();
          });
        }
      });
    });
  }
  async addPasskey() {
    try {
      const trustedSession1 = await this.args.model.trustedSession();
      if (!trustedSession1.success) {
        this.dialog.dialog({
          title: I18n.t("user.confirm_access.title"),
          type: "notice",
          bodyComponent: ConfirmSession,
          didConfirm: () => this.createPasskey()
        });
      } else {
        await this.createPasskey();
      }
    } catch (error1) {
      popupAjaxError(error1);
    }
  }
  async deletePasskey(id1) {
    try {
      const trustedSession1 = await this.args.model.trustedSession();
      if (!trustedSession1.success) {
        this.dialog.dialog({
          title: I18n.t("user.confirm_access.title"),
          type: "notice",
          bodyComponent: ConfirmSession,
          didConfirm: () => this.confirmDelete(id1)
        });
      } else {
        this.confirmDelete(id1);
      }
    } catch (error1) {
      popupAjaxError(error1);
    }
  }
  renamePasskey(id1, name1) {
    this.dialog.dialog({
      title: I18n.t("user.passkeys.rename_passkey"),
      type: "notice",
      bodyComponent: RenamePasskey,
      bodyComponentModel: {
        id: id1,
        name: name1
      }
    });
  }
}, setComponentTemplate(createTemplateFactory(
/*
  
    <div class="control-group pref-passkeys">
      <label class="control-label">
        {{i18n "user.passkeys.title"}}
      </label>
      <div class="instructions">
        {{i18n "user.passkeys.short_description"}}
      </div>

      <div class="pref-passkeys__rows">
        {{#each @model.user_passkeys as |passkey|}}
          <div class="row">
            <div class="passkey-left">
              <div class="row-passkey__name">{{passkey.name}}</div>
              <div class="row-passkey__created-date">
                {{htmlSafe
                  (i18n
                    "user.passkeys.added_date"
                    date=(formatDate
                      passkey.created_at format="medium" leaveAgo="true"
                    )
                  )
                }}
              </div>
              <div class="row-passkey__used-date">
                {{#if passkey.last_used}}
                  {{htmlSafe
                    (i18n
                      "user.passkeys.last_used_date"
                      date=(formatDate
                        passkey.last_used format="medium" leaveAgo="true"
                      )
                    )
                  }}
                {{else}}
                  {{i18n "user.passkeys.never_used"}}
                {{/if}}
              </div>
            </div>
            {{#if this.showActions}}
              <div class="passkey-right">
                <div class="actions">
                  <PasskeyOptionsDropdown
                    @deletePasskey={{fn this.deletePasskey passkey.id}}
                    @renamePasskey={{fn
                      this.renamePasskey
                      passkey.id
                      passkey.name
                    }}
                  />
                </div>
              </div>
            {{/if}}
          </div>
        {{/each}}
      </div>

      {{#if this.showActions}}
        <div class="controls pref-passkeys__add">
          <DButton
            @action={{this.addPasskey}}
            @icon="plus"
            @label="user.passkeys.add_passkey"
          />
        </div>
      {{/if}}
    </div>
  
*/
{
  "id": "WtAUhyvw",
  "block": "[[[1,\"\\n    \"],[10,0],[14,0,\"control-group pref-passkeys\"],[12],[1,\"\\n      \"],[10,\"label\"],[14,0,\"control-label\"],[12],[1,\"\\n        \"],[1,[28,[32,0],[\"user.passkeys.title\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"instructions\"],[12],[1,\"\\n        \"],[1,[28,[32,0],[\"user.passkeys.short_description\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[10,0],[14,0,\"pref-passkeys__rows\"],[12],[1,\"\\n\"],[42,[28,[31,1],[[28,[31,1],[[30,1,[\"user_passkeys\"]]],null]],null],null,[[[1,\"          \"],[10,0],[14,0,\"row\"],[12],[1,\"\\n            \"],[10,0],[14,0,\"passkey-left\"],[12],[1,\"\\n              \"],[10,0],[14,0,\"row-passkey__name\"],[12],[1,[30,2,[\"name\"]]],[13],[1,\"\\n              \"],[10,0],[14,0,\"row-passkey__created-date\"],[12],[1,\"\\n                \"],[1,[28,[32,1],[[28,[32,0],[\"user.passkeys.added_date\"],[[\"date\"],[[28,[32,2],[[30,2,[\"created_at\"]]],[[\"format\",\"leaveAgo\"],[\"medium\",\"true\"]]]]]]],null]],[1,\"\\n              \"],[13],[1,\"\\n              \"],[10,0],[14,0,\"row-passkey__used-date\"],[12],[1,\"\\n\"],[41,[30,2,[\"last_used\"]],[[[1,\"                  \"],[1,[28,[32,1],[[28,[32,0],[\"user.passkeys.last_used_date\"],[[\"date\"],[[28,[32,2],[[30,2,[\"last_used\"]]],[[\"format\",\"leaveAgo\"],[\"medium\",\"true\"]]]]]]],null]],[1,\"\\n\"]],[]],[[[1,\"                  \"],[1,[28,[32,0],[\"user.passkeys.never_used\"],null]],[1,\"\\n\"]],[]]],[1,\"              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n\"],[41,[30,0,[\"showActions\"]],[[[1,\"              \"],[10,0],[14,0,\"passkey-right\"],[12],[1,\"\\n                \"],[10,0],[14,0,\"actions\"],[12],[1,\"\\n                  \"],[8,[32,3],null,[[\"@deletePasskey\",\"@renamePasskey\"],[[28,[32,4],[[30,0,[\"deletePasskey\"]],[30,2,[\"id\"]]],null],[28,[32,4],[[30,0,[\"renamePasskey\"]],[30,2,[\"id\"]],[30,2,[\"name\"]]],null]]],null],[1,\"\\n                \"],[13],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],null],[1,\"          \"],[13],[1,\"\\n\"]],[2]],null],[1,\"      \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"showActions\"]],[[[1,\"        \"],[10,0],[14,0,\"controls pref-passkeys__add\"],[12],[1,\"\\n          \"],[8,[32,5],null,[[\"@action\",\"@icon\",\"@label\"],[[30,0,[\"addPasskey\"]],\"plus\",\"user.passkeys.add_passkey\"]],null],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n  \"]],[\"@model\",\"passkey\"],false,[\"each\",\"-track-array\",\"if\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-app/components/user-preferences/user-passkeys.js",
  "scope": () => [i18n, htmlSafe, formatDate, PasskeyOptionsDropdown, fn, DButton],
  "isStrictMode": true
}), _UserPasskeys), _UserPasskeys), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "dialog", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "currentUser", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "capabilities", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "addPasskey", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addPasskey"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deletePasskey", [action], Object.getOwnPropertyDescriptor(_class.prototype, "deletePasskey"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "renamePasskey", [action], Object.getOwnPropertyDescriptor(_class.prototype, "renamePasskey"), _class.prototype)), _class);
export { UserPasskeys as default };